

export const onCodeCreate = (values) => {

    const errors = {}
   
   
    if (required(values.status )) {
        errors.status  = 'Status required'
    }

     if (required(values.type )) {
        errors.type  = 'Type required'
    }

    if (values.type === 'Article' && required(values.code)) {
    errors.code = ' Code is required when type is Article';
}

  if (values.type === 'Video' && required(values.start_code)) {
    errors.start_code = 'Start Code is required when type is Video';
}

 if (values.type === 'Video' && required(values.end_code)) {
    errors.end_code = 'End Code is required when type is Video';
}
    

    return errors;
   
};

export const onCodeEdit = (values) => {

    const errors = {}
   
    if (required(values.type )) {
        errors.type  = 'Type required'
    }

    if (required(values.status )) {
        errors.status  = 'Status required'
    }

    if (values.type === 'Article' && required(values.code)) {
    errors.code = ' Code is required when type is Article';
}

  if (values.type === 'Video' && required(values.start_code)) {
    errors.start_code = 'Start Code is required when type is Video';
}

 if (values.type === 'Video' && required(values.end_code)) {
    errors.end_code = 'End Code is required when type is Video';
}
    

    return errors;
};

















const isEmpty = (value: any) =>{
    return (typeof value === 'undefined' || value === null || value === '')
}

export const required = (value) =>{
    return isEmpty(value)
}


